import axios from 'axios'
import {PaginateModel} from '../../../shared/models/PaginateModel'
import {cleanupPaginationParams} from '../../../shared/utils'

const API_URL = process.env.REACT_APP_API_URL
export const BILLING_BASE_URL = `${API_URL}/account/transactions`
export const PAYMENT_TRANSACTIONS_BASE_URL = `${API_URL}/payments/revenue-transactions`

export function getAllUserTransaction(params: PaginateModel) {
  return axios.get(BILLING_BASE_URL, {
    params: cleanupPaginationParams(params),
  })
}
export function getAllUserPaymentRequest(params: PaginateModel) {
  return axios.get(PAYMENT_TRANSACTIONS_BASE_URL, {
    params: cleanupPaginationParams(params),
  })
}

export function downloadDocument(transactionId: number) {
  return axios.get(BILLING_BASE_URL + '/' + transactionId + '/get-document')
}

export function getTransactionStatistics(startDate: string, endDate: string) {
  return axios.get(BILLING_BASE_URL + '/statistics', {
    params: {
      startDate,
      endDate,
    },
  })
}
export function getTotalCreditUsage() {
  return axios.get(BILLING_BASE_URL + '/usage')
}

// Payment Transactions API
export function getAllPaymentTransactions(params: PaginateModel) {
  return axios.get(PAYMENT_TRANSACTIONS_BASE_URL, {
    params: cleanupPaginationParams(params),
  })
}

export function downloadPaymentDocument(
  userId: string,
  month: string,
  paymentTransactionId?: string
) {
  return axios.post(`${API_URL}/payments/download-document`, {
    userId,
    month,
    paymentTransactionId,
  })
}
